<template>
  <v-btn
    color="info"
    :depressed="isVerified"
    :disabled="isVerified"
    :outlined="!isVerified"
    @click="onVerify"
  >
    <div
      class="px-5"
      v-text="label"
    />
  </v-btn>
</template>

<script>
export default {
  name: 'BaseVerifyButton',
  props: {
    value: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      internalValue: false,
    };
  },
  computed: {
    isVerified() {
      return this.value !== undefined ? this.value : this.internalValue;
    },
    label() {
      return this.isVerified
        ? this.$t('labels.verified')
        : this.$t('labels.verify');
    },
  },
  methods: {
    onVerify() {
      if (this.value !== undefined) {
        this.$emit('input', true);
      }
      else {
        this.internalValue = true;
      }
    },
  },
};
</script>
